<template>
  <div v-bind:style="{'display': display ? '' : 'none'}">
    <div class="modal-header">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body">
      <div v-if="errorResponse" class="alert alert-danger" role="alert">
        <ul>
          <li v-for="e in nonFieldErrors">{{ e }}</li>
          <li v-for="errors in fieldErrors" v-if="errors.length">
            {{ formLabels[$key] }}
            <ul>
              <li v-for="e in errors">{{ e }}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group form-group-sm required"
               v-bind:class="{'has-error': fieldErrors.startAt.length}">
            <label class="control-label">希望日時</label>
            <div class="form-inline">
              <datepicker
                 :value.sync="startDate"
                 @change="changeDate"
                 date-format="YYYY-MM-DD (dd)"
                 :width="150"
                 ></datepicker>
              <timepicker
                 :value.sync="startTime"
                 :start-at="openTime"
                 :step-in-minutes="10"
                 :end-at="closeTime"
                 ></timepicker>
            </div>
          </div>
          <div class="form-group form-group-sm required"
               v-bind:class="{'has-error': fieldErrors.menu.length || fieldErrors.menuOptions.length}">
            <label class="control-label" for="menu-{{ _uid }}">メニュー</label>
            <select id="menu-{{ _uid }}" class="form-control" v-model="menu" @change="changeMenu">
              <option></option>
              <option v-for="m in menus" :value="m">{{ m.name }}</option>
            </select>
            <template v-if="menu">
            <div v-for="o in menu._embedded.options" class="checkbox">
                <input type="checkbox" :value="o" style="margin-left: 20px;" v-model="menuOptions">
                <label style="heigth: 40px; padding-top: 12px; margin-left: 22px;">{{ o.name }}</label>
            </div>
            </template>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group form-group-sm required" v-if="!notFound">
            <label class="control-label" for="time-{{ _uid }}">予約可能時間</label>
            <select id="time-{{ _uid }}" class="form-control" style="height: 300px;" v-model="selectTime" size="10">
              <option></option>
              <option
                v-for="obj in results"
                v-bind:class="{nearest: obj.isNearest}"
                :value="obj.datetime">{{ obj.datetime|printTime }}</option>
            </select>
          </div>
          <div v-else>
            予約可能な時間帯がありません。
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-sm-6">
          <button class="btn btn-primary" :disabled="!menu" @click="waitFor(searchTime())">検索する</button>
        </div>
        <div class="col-sm-6">
          <button :disabled="!selectTime" @click="submit" class="btn btn-success">時間を確定する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import moment from 'moment'
moment.locale('ja')

export default {
  name: 'reservation-table-modal-form-time-select',
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    shop: {
      type: Object,
      required: true,
    },
    menus: {
      type: Array,
      required: true,
    },
    businessHour: {
      type: Object,
      required: true,
    },
  },
  events: {
    'prepare-create': function (createAt) {
      this.reset()
      this.startAt = createAt
      this.menu = this.menus.find(x => x.name === 'リタッチ')
    },
    'show-time-select': function (startAt, menu, menuOptions, reservationPk) {
      this.reset()
      this.startAt = startAt
      this.menu = menu
      this.menuOptions = menuOptions
      this.reservationPk = reservationPk
      if (reservationPk) {
        this.reservationStartAt = startAt
      }
    },
  },
  filters: {
    printTime (val) {
      let tmp = moment(val)
      return tmp.format('HH:mm')
    },
  },
  computed: {
    startDate: {
      get() {
        return moment(this.startAt).format('YYYY-MM-DD')
      },
      set(val) {
        let t = moment(val, 'YYYY-MM-DD')
        this.startAt = moment(this.startAt).set({
          'year': t.year(),
          'month': t.month(),
          'date': t.date()
        }).toISOString()
      }
    },
    startTime: {
      get() {
        return moment(this.startAt).format('HH:mm')
      },
      set(val) {
        let t = moment(val, 'HH:mm')
        this.startAt = moment(this.startAt).set({'hour': t.hour(), 'minute': t.minute()}).toISOString()
      }
    },
    openTime() {
      return moment(this.businessHour.openAt).format('HH:mm')
    },
    closeTime() {
      return moment(this.businessHour.closeAt).format('HH:mm')
    },
    fieldErrors () {
      let errors = {}
      let e = this.errorResponse ? this.errorResponse.body : {}
      let ec = e.customer

      Object.assign(errors, {
        startAt: e.startAt ? e.startAt : [],
        menu: e.menu ? e.menu : [],
        menuOptions: e.menuOptions ? e.menuOptions : [],
      })
      return errors
    },
  },
  data () {
    return this.defaultData()
  },
  methods: {
    defaultData () {
      return {
        results: [],
        errorResponse: null,
        startAt: null,
        menu: null,
        menuOptions: [],
        selectTime: null,
        notFound: false,
        reservationPk: null,
        reservationStartAt: null,
      }
    },
    reset () {
      let data = this.defaultData()
      Object.keys(data).forEach(k => this[k] = data[k])
    },
    changeMenu () {
      this.menuOptions = []
      this.results = []
      this.selectTime = null
    },
    changeDate () {
      this.results = []
      this.selectTime = null
    },
    searchTime () {
      let data = {
        date: this.startDate,
        shop: this.shop.pk,
        menu: this.menu ? this.menu.pk : null,
        exclude_reservation: this.reservationPk,
        for_shop: true,
      }
      this.results = []
      this.notFound = false
      this.errorResponse = null
      return this.apiGet(
          `/api/1.0/reservations/reservable-times/`,
          data,
          {shopAs: this.shop.pk}
      ).then(response => {
        let results = []
        let diffs = []
        let startAt = moment(this.startAt)
        response.body.results.filter(x => x.isAvailable).forEach(obj => {
          let tmp = moment(obj.datetime)
          let diff = Math.abs(startAt.diff(tmp))
          if (diff === 0) {
            this.selectTime = obj.datetime
          }
          diffs.push(diff)
          obj.diff = diff
          results.push(obj)
        })

        if (this.reservationStartAt && !results.find(x => moment(x.datetime).diff(moment(this.reservationStartAt)) === 0)) {
          if(moment(this.reservationStartAt).format('YYYY-MM-DD') === moment(this.startAt).format('YYYY-MM-DD')) {
            let diff = Math.abs(moment(this.startAt).diff(moment(this.reservationStartAt)))
            let obj = {
              datetime: this.reservationStartAt,
              diff: diff,
            }
            if (diff === 0) {
              this.selectTime = this.reservationStartAt
            }
            results.push(obj)
          }
        }

        let min = Math.min.apply(null, diffs)
        results.map(x => x.isNearest = (x.diff === min))
        this.results = results
        if (results.length === 0) {
          this.notFound = true
        }
      }).catch(reason => {
        if (reason.error.status === 400) {
          this.errorResponse = reason.response
        }
        return Promise.reject(reason)
      })
    },
    submit () {
      this.$dispatch('time-select', this.selectTime, this.menu, this.menuOptions)
      this.$dispatch('switch-modal', 'edit')
    },
  },
  mixins: [
    require('mixin/api-client.vue'),
    require('mixin/wait.vue'),
  ],
  components: {
    datepicker: require('ui/datepicker.vue'),
    timepicker: require('ui/timepicker.vue'),
  },
}
</script>

<style scoped>
.nearest {
  color: red;
}
</style>



// WEBPACK FOOTER //
// time-select.vue?0ff6d78b